import { styled } from '@/utils';
import { Box, BoxProps } from '../Box';
import { DrawerContextValue, useRequiredDrawerContext } from './DrawerContextProvider';

export interface DrawerContentProps extends Pick<BoxProps, 'id'> {
  /**
   * The contents of the drawer.
   */
  children: React.ReactNode;
}

export function DrawerContent({ children, id }: DrawerContentProps) {
  const { size } = useRequiredDrawerContext();

  return (
    <DrawerContentContainer id={id} size={size}>
      {children}
    </DrawerContentContainer>
  );
}

const DrawerContentContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<Pick<DrawerContextValue, 'size'>>(({ theme, size }) => {
  return {
    flexGrow: 1,
    overflowY: 'auto',
    padding: theme.spacing(2),
    background: size === 'small' ? theme.palette.background.container : theme.palette.background.canvas,
  };
});
